"use client";

import { useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CartProduct from "@/components/CartProduct";
import classes from "./styles/Items.module.css";
import Link from "next/link";
import { Product } from "@/types/productsType";

export const products: Product = {
    id: 1,
    title: "ژل ماشین ظرفشویی پروشاین",
    description: "ژل شست‌وشوی قوی برای ظروف با حجم 1000 میلی‌لیتر",
    price: 180000,
    discountPrice: 145000,
    image: "/images/products/gel.jpg",
    discountPercent: 20,
}



const TextSlider: React.FC<{ text: string , link: string }> = ({ text , link}) => {
  const sliderRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between p-5 rounded-lg">
        <div>
          <Link href={`/${link}`}>
            <span className={classes.name}>{text}</span>
          </Link>
        </div>
        <div className={classes.LRIcon}>
          <button
            className="bg-white text-gray-800 p-2 rounded-full hover:bg-gray-400 transition"
            onClick={scrollRight}
          >
            <FaChevronRight size={18} />
          </button>
          <button
            className="bg-white text-gray-800 p-2 rounded-full hover:bg-gray-400 transition"
            onClick={scrollLeft}
          >
            <FaChevronLeft size={18} />
          </button>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div
          ref={sliderRef}
          className="flex overflow-x-scroll scroll-smooth scrollbar-hide"
          style={{
            scrollbarWidth: "none", 
            msOverflowStyle: "none", 
          }}
        >
          {[...Array(10)].map((_, index) => (
            <div key={index} >
              <CartProduct  product={products} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TextSlider;
